<template>
    <v-theme-provider theme="light">
        <v-app>
            <v-app-bar color="primary">
                <template #title>
                    <router-link
                        to="/"
                        class="text-decoration-none text-white d-inline-flex justify-start align-center"
                        style="vertical-align: bottom"
                    >
                        <v-img
                            src="/logo-med.webp"
                            alt=""
                            height="28px"
                            width="28px"
                            class="d-inline align-middle mr-2"
                        />
                        Studoku
                    </router-link>
                </template>
            </v-app-bar>
            <v-main>
                <div
                    class="fill-height d-flex align-center"
                    style="
                        background: linear-gradient(
                            135deg,
                            #e3f2fd 0%,
                            #f3e5f5 50%,
                            #fff3e0 100%
                        );
                    "
                >
                    <v-container
                        class="fill-height d-flex align-center justify-center"
                        fluid
                    >
                        <v-row
                            justify="center"
                            class="w-100"
                        >
                            <v-col
                                cols="12"
                                sm="8"
                                md="6"
                                lg="4"
                                xl="3"
                            >
                                <router-view />
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-main>
            <v-footer
                color="grey-lighten-4"
                class="text-center py-4 flex-0-0"
            >
                <v-container class="py-0">
                    <v-row class="ma-0">
                        <v-col
                            cols="12"
                            class="py-2"
                        >
                            <div
                                class="d-flex justify-center align-center flex-wrap mb-2"
                            >
                                <router-link
                                    to="/privacy-policy"
                                    class="text-decoration-none text-primary mx-2"
                                >
                                    Privacy Policy
                                </router-link>
                                <span class="text-grey-darken-2 mx-1">•</span>
                                <router-link
                                    to="/terms-of-service"
                                    class="text-decoration-none text-primary mx-2"
                                >
                                    Terms of Service
                                </router-link>
                            </div>
                            <p class="text-body-2 text-grey-darken-1 mb-0">
                                © 2025 Studoku. All rights reserved.
                            </p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-footer>
        </v-app>
    </v-theme-provider>
</template>

<style scoped>
.v-main {
    min-height: calc(
        100vh - 64px - 56px
    ); /* Subtract app bar and footer height */
}
</style>
